export const MODULE_DETAILS_LIST = "MODULE_DETAILS_LIST";